import React, { useEffect, useState } from "react";
import { Card } from "@tremor/react";
import { baseImgURL, baseURL } from "./backend/baseData";
import axios from "axios";
import { Link } from "react-router-dom";
const Districts = () => {
  const [districts, setDistricts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    const fetchDistricts = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/getAllAdminDistricts.php?id=2`
        );
        if (response.status === 200 && Array.isArray(response.data)) {
          console.log(response.data);
          setDistricts(response.data);
        } else {
          console.error("Invalid response format or failed to fetch districts");
          setDistricts([]);
        }
      } catch (error) {
        console.error("Error while fetching districts:", error.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchDistricts();
  }, []);
  return (
    <div className="w-full flex-grow p-3">
      <div>Navbar</div>
      <div className="w-full grid grid-cols-12 mt-5 gap-3">
        {districts.length > 0 &&
          districts.map((item,index) => {
            return (
              <div className="col-span-12 md:col-span-6 lg:col-span-4" key={index}>
                <div className="max-w-sm bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">
                  <Link to="#">
                    <img
                      className="rounded-t-lg h-52 w-full object-cover"
                      src={baseImgURL + item.image}
                      alt={item.title}
                    />
                  </Link>
                  <div className="p-5 min-h-48">
                    <Link to="#">
                      <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
                        {item.title}
                      </h5>
                    </Link>
                    <p className="mb-3 font-normal text-gray-700 dark:text-gray-400">
                      {item.description && item.description.length > 150
                        ? `${item.description.substring(0, 150)}...`
                        : item.description}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default Districts;
